import React from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import styles from './IntegrationModal.module.scss';

function IntegrationModal(props) {
  const { onClose, open } = props;

  return (
    <ModalWindow open={open} onClose={onClose} center size="small">
      <h2>Add eCom integration</h2>
      <hr />
      <div className={styles.body}>
        <p>In most cases integration with Cymbio takes about 10 mins.</p>
        <p>
          Please contact <a href="mailto:integration@cym.bio">integration@cym.bio</a> to receive instructions
        </p>
      </div>
      <hr />
      <div className={styles.footer}>
        <Button text="OK" onClick={onClose} />
      </div>
    </ModalWindow>
  );
}

export default IntegrationModal;

IntegrationModal.defaultProps = {
  open: false,
};

IntegrationModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};
